const recoverPwForm = () => {
  const pwRecoverForm = document.querySelector("form#recover_customer_password")
  const recoverPwButton = pwRecoverForm.querySelector(
    "button#RecoverPasswordButton",
  )
  const email = pwRecoverForm.querySelector("input#RecoverEmail")
  const validationIgnoreKeys = ["Shift", "Tab"]
  const thisModal = pwRecoverForm.closest("modal-dialog")

  const init = () => {
    recoverPwButton.addEventListener("click", recoverPassword)
    document.querySelector("h1#recover").addEventListener("focus", () => {
      hideErrorMessages()
      if (email.value && !email.checkValidity()) displayErrorMessage(email)
      email.focus()
    })

    // init text fields
    const recoverTexts = pwRecoverForm.querySelectorAll(
      "input[type='text'],input[type='email']",
    )
    for (idx in recoverTexts) {
      const txtInput = recoverTexts[idx]
      if (typeof txtInput === "object") {
        txtInput.addEventListener("keyup", (evt) => {
          const txtInput = evt.target
          if (!validationIgnoreKeys.includes(evt.key)) {
            hideErrorMessages(txtInput)
          }
        })
        txtInput.addEventListener("blur", (evt) => {
          txtInput.value = txtInput.value.trim()
          if (!txtInput.checkValidity()) {
            setTimeout(displayErrorMessage, 200, txtInput)
          }
        })
      }
    }
  }

  const displayErrorMessage = (input, message) => {
    if (input) {
      const field = input.closest(".field")
      const errorMsg = field.nextElementSibling
      field.classList.add("error")
      errorMsg.classList.remove("hidden")
      input.setAttribute("aria-invalid", "true")
      input.setAttribute(
        "aria-describedby",
        "Error-" + input.getAttribute("id"),
      )
      if (message) {
        errorMsg.innerHTML = message
      } else {
        errorMsg.innerHTML = errorMsg.getAttribute("data-default")
      }
    }
  }

  const hideErrorMessages = (input) => {
    let inputs = input
      ? [input]
      : pwRecoverForm.querySelectorAll(".field > input")
    for (idx in inputs) {
      let input = inputs[idx]
      if (typeof input === "object") {
        const field = input.closest(".field")
        const errorMsg = field.nextElementSibling
        field.classList.remove("error")
        errorMsg.innerHTML = ""
        errorMsg.classList.add("hidden")
        input.removeAttribute("aria-invalid")
        input.removeAttribute("aria-describedby")
      }
    }
  }

  const recoverPassword = async (event) => {
    event.preventDefault()
    hideErrorMessages()
    let errors = false
    if (!email.checkValidity()) {
      displayErrorMessage(email)
      errors = true
    }
    if (errors) return

    try {
      recoverPwButton.disabled = true
      const body = {
        event: "request-password-reset",
        email: email.value,
      }
      const response = await fetch("/apps/custom-events", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
      const responseJson = await response.json()

      if (response.status !== 200) {
        recoverPwButton.disabled = false
        let message = responseJson.message
        if (message === "COGNITO_FAILURE") {
          message = responseJson.payload.error
        }
        const errorMsg = pwRecoverForm.querySelector("#" + message)
        if (errorMsg) {
          displayErrorMessage(email, errorMsg.innerHTML)
          return
        }
        displayErrorMessage(email, message)
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        })

        dataLayer.push({
          event: "reset_password_request_failure",
          message: message,
          page_location: window.location.href,
        })

        return
      }
      pwRecoverForm.reset()
      document
        .querySelector("#recover-password-message-success")
        .classList.remove("hidden")

      dataLayer.push({
        event: "reset_password_request",
        page_location: window.location.href,
      })

      const elModalReset = document.querySelector(
        thisModal?.dataset?.resetModalSelector,
      )
      if (elModalReset) {
        // if in modal
        thisModal.hide()
        elModalReset.show()
      } else {
        location.href =
          "/pages/reset-password-confirmation?email=" + btoa(body.email)
      }
    } catch (error) {
      displayErrorMessage(email, "Unexpected error")
      console.error(error)
    } finally {
      recoverPwButton.disabled = false
    }
  }

  init()
}
recoverPwForm()
